export default {
  namespaced: true,
  state: {
    sidebarNavigation: true,
  },
  actions: {},
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebarNavigation = !state.sidebarNavigation
    },
  },
}
